import React from 'react';
import './ProductCard.css';

function ProductCard({ product, addToCart }) {
  const handleAddToCart = (e) => {
    e.stopPropagation();
    addToCart(product);
  };

  return (
    <div className="luxury-product-card">
      <div className="card-border-outer">
        <div className="card-border-inner">
          <div className={`product-card-image-wrapper ${product.imageFit === 'contain' ? 'contain-mode' : ''}`}>
            <img
              src={product.image}
              alt={product.name}
              className="product-card-img"
              style={product.imageFit === 'contain' ? { objectFit: 'contain' } : undefined}
              loading="lazy"
            />
          </div>

          <h3 className="product-card-title">{product.name}</h3>
          
          <div className="product-card-price">
            {product.price} SAR
          </div>

          {product.halal !== false && (
            <div className="product-card-halal">
              <span className="halal-check">✔</span> Halal Certified
            </div>
          )}

          <button
            className="luxury-add-btn"
            onClick={handleAddToCart}
          >
            [ Add to Cart ]
          </button>
        </div>
      </div>
    </div>
  );
}

export default ProductCard;
